import { render } from "./ViewOrderCollection.html?vue&type=template&id=6fdfd6ea&scoped=true"
import script from "./ViewOrderCollection.js?vue&type=script&lang=js"
export * from "./ViewOrderCollection.js?vue&type=script&lang=js"

import "./ViewOrderCollection.css?vue&type=style&index=0&id=6fdfd6ea&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdfd6ea"]])

export default __exports__